import { Api } from '@/services/Api'

export default {
  fetchNotification(param, skip, limit) {
    return Api().get(`/api/v2/notification/${param}/${skip}/${limit}`)
  },
  fetchNotificationCount(param) {
    return Api().get(`/api/v2/notification/count/${param}`)
  }
}
